export default {
    smartSearch: {
        errorsTipNum: '{num} 处错误',
        errorCode: {
            10001: '字段名称错误',
            10002: '不能嵌套检索字段，该字段名称被当做文本识别',
            10003: '该命令只能在ANS/ANCS/ALL_AN字段下使用',
            10004: '语法错误',
            20001: '不能以逻辑词开头',
            20002: '不能连续出现多个逻辑词',
            20003: '不能以逻辑词结尾',
            20004: '逻辑运算符个数超过1024个',
            30001: '字段值为空',
            30002: '缺少符号:)',
            30003: '多余符号:)',
            30004: '缺少符号:]',
            30005: '多余符号:]',
            30006: '缺少符号:"',
            30007: "缺少符号:'",
            30008: '缺少符号:|',
            40001: '位置符格式错误',
            40002: '频率运算符格式错误',
            40003: '位置符个数超过15个',
            40004: 'n最大值为50',
            40005: '语法错误',
            50001: '字段值错误',
            50002: '该字段仅能输入日期(YYYY or YYYYMM or YYYYMMDD)',
            50003: '结束日期不能早于开始日期',
            50004: '该字段仅能输入正整数',
            50005: '数字格式未从小到大',
            60001: '检索式格式错误',
            70001: '该特殊检索式格式错误',
            70002: '同一个搜索语句只能包含一个特殊检索式',
            70003: '特殊检索式的位置只能在检索式开头',
            70004: '请将文件夹路径放在||内',
            70005: '请将层级字段、选项字段的标引值放在""内',
            70006: '请将not blank放在""内',
            80001: 'R命令只能使用AND连接',
            80002: '检索语句中只能出现一个R命令',
            80003: 'R命令的位置只能在检索式的开头。',
        },
        nodata: '无数据',
    },
};
